import React from "react";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import { ImageOutlined } from "@mui/icons-material";

function Image({ data, addSchedule, deleteSingleContent, readOnly = false }) {
  return (
    <div className="content-item" key={data.key || data.id}>
      <div className="content-image">
        {!readOnly && (
          <div className="content-del-icon">
            <DeleteOutlineIcon
              onClick={() => deleteSingleContent(data.id)}
              style={{ color: "var(--primary-color)" }}
            />
          </div>
        )}
        <img src={data.url} alt={data?.name || ""} />
      </div>
      <div className="content-bottom">
        <p>{data.name?.substring(0, 20)}</p>
        <p style={{ display: "flex", alignItems: "center" }}>
          <span>
            <ImageOutlined sx={{ fontSize: "15px", color: "var(--primary-color)" }} />
          </span>
          <span>Image</span>
        </p>
      </div>
    </div>
  );
}

export default Image;